<form [formGroup]="loanRefinanceForm">
  <table class="w-100 border1 scenario">
    <tr>
      <th style="min-width: 280px !important">
        {{ heading }}
        <button *ngIf="!isCurrentMortgage && isDelete" class="action">
          <mat-icon (click)="selectedLoanAction(loanId, 'delete')">delete</mat-icon>
        </button>
      </th>
    </tr>
    <tr>
      <td>{{ principalBalance | currency: 'USD':'symbol':'0.0-0' }}</td>
    </tr>
    <tr>
      <td>
        <div class="mcmortgage" *ngIf="!isCurrentMortgage">
          <mat-form-field class="w-25">
            <input type="number" class="text-center" matInput formControlName="closeByYearsInput" />

            <span matSuffix>Year</span>
          </mat-form-field>
          <mat-slider
            (input)="onSliderChange($event)"
            class="ml-3"
            min="0"
            max="30"
            formControlName="closeByYearsSlider"
            thumbLabel
            aria-label="units"
          ></mat-slider>
        </div>
        <div class="error-mes" style="color: red" *ngIf="closeByYearsInputValid">Enter a year between 0 to 30</div>
        <span *ngIf="isCurrentMortgage">{{ term / 12 }} years </span>
      </td>
    </tr>

    <tr>
      <td>
        <mat-form-field class="w-25" *ngIf="!isCurrentMortgage">
          <input
            *ngIf="!isCurrentMortgage"
            matInput
            class="text-center"
            name="interestRate"
            type="number"
            autocomplete="off"
            formControlName="interestRateInput"
          />
          <span matSuffix>%</span>
        </mat-form-field>
        <mat-slider
          (input)="onSliderChange($event)"
          formControlName="interestRateSlider"
          *ngIf="!isCurrentMortgage"
          class="ml-3"
          tickInterval="1"
          step="1"
          min="0"
          max="15"
          aria-label="units"
        ></mat-slider>
        <div class="mb-0 error-mes" style="color: red" *ngIf="interestRateInputValid">Enter a rate between 0 to 15</div>
        <span *ngIf="isCurrentMortgage">{{ interestRate }} %</span>
      </td>
    </tr>

    <tr>
      <td>
        <span *ngIf="!isCurrentMortgage" matSuffix>$</span>
        <mat-form-field class="w-25" *ngIf="!isCurrentMortgage">
          <input
            matInput
            formControlName="closingCostInput"
            currencyMask
            name="closingCost"
            class="text-center"
            autocomplete="off"
          />
        </mat-form-field>
        <span *ngIf="isCurrentMortgage">--</span>
        <!-- <mat-slider
          formControlName="closingCostSlider"
          *ngIf="!isCurrentMortgage"
          class="ml-3"
          thumbLabel
          aria-label="units"
        ></mat-slider> -->
      </td>
    </tr>

    <tr>
      <td>
        <span *ngIf="isCurrentMortgage"> --</span>
        <span *ngIf="!isCurrentMortgage">{{ loanMonthlyPayment | currency: 'USD':'symbol':'0.0-0' }}</span>
      </td>
    </tr>

    <tr>
      <td>
        <span *ngIf="isCurrentMortgage">
          <span *ngIf="isCurrentYears"> {{ isCurrentYears | number: '1.0-0' }} years </span
          ><span *ngIf="isCurrentMonths">{{ isCurrentMonths | number: '1.0-0' }} months</span>
        </span>
        <span *ngIf="isCurrentMortgage && !isCurrentYears && !isCurrentMonths">--</span>
        <span *ngIf="!isCurrentMortgage">
          <span *ngIf="closeByYears"> {{ closeByYears | number: '1.0-0' }} years </span
          ><span *ngIf="closeByMonths"> {{ closeByMonths | number: '1.0-0' }} months</span>
        </span>
      </td>
    </tr>

    <tr>
      <td>
        <span *ngIf="isCurrentMortgage">--</span>
        <span *ngIf="!isCurrentMortgage">{{ (changeInMonthlyPayment | currency: 'USD':'symbol':'0.0-0') || 0 }} </span>
      </td>
    </tr>
    <tr>
      <td>
        <span *ngIf="isCurrentMortgage">--</span>
        <span *ngIf="!isCurrentMortgage"> {{ (totalInterestChange | currency: 'USD':'symbol':'0.0-0') || 0 }} </span>
      </td>
    </tr>

    <tr>
      <td>
        <span *ngIf="isCurrentMortgage">--</span>
        <span *ngIf="!isCurrentMortgage"> {{ (totalInterestSaved | currency: 'USD':'symbol':'0.0-0') || 0 }} </span>
      </td>
    </tr>

    <tr>
      <td>
        <span *ngIf="isCurrentMortgage">--</span>
        <span *ngIf="!isCurrentMortgage">
          {{ timeBreakEvent < 0 ? timeBreakEvent * -(1).toFixed(0) : timeBreakEvent.toFixed(0) }} Months
        </span>
      </td>
    </tr>
    <!-- <tr>
      <td>
        <button
          mat-flat-button
          [ngClass]="{ 'mat-flat-button': isActive, 'mat-stroked-button': !isActive }"
          (click)="selectedLoanAction(loanId, 'active')"
          color="primary"
        >
          Choose this Scenario
        </button>
      </td>
    </tr> -->
  </table>
</form>
